module.exports = __webpack_public_path__ + "img/logo_roxo.095bb24d.png";